// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';
export const MoreSvgIcon = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg width="1em" height="1em" viewBox="0 0 100 100" {...props}>
    <path d="M49.958 42a7.913 7.913 0 00-7.916 7.917 7.913 7.913 0 007.916 7.916 7.913 7.913 0 007.917-7.916A7.913 7.913 0 0049.958 42zm-32.041 0A7.913 7.913 0 0010 49.917a7.913 7.913 0 007.917 7.916 7.913 7.913 0 007.916-7.916A7.913 7.913 0 0017.917 42zm64.166 0a7.913 7.913 0 00-7.916 7.917 7.913 7.913 0 007.916 7.916A7.913 7.913 0 0090 49.917 7.913 7.913 0 0082.083 42z" />
  </svg>
);
